export const auxiliaryOptions = [
  {
    value: 'OFF',
    text: 'Off',
    setpoint: undefined,
  },
  {
    value: 'MANUAL',
    text: 'On',
    setpoint: undefined,
  },
];
